// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'video-solid';

export const Component = () => (
  <path d='m22.984 6.191-4.31 3.114v-1.82c0-.431-.144-.766-.432-1.054A1.408 1.408 0 0 0 17.188 6H2.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 1 7.485v9.818c0 .431.144.767.431 1.054.288.288.623.431 1.054.431h14.703c.432 0 .767-.143 1.054-.431.288-.287.431-.623.431-1.054v-1.82l4.31 3.114a.919.919 0 0 0 .576.191c.239 0 .479-.096.718-.335a.946.946 0 0 0 .288-.67V7.007c0-.239-.096-.479-.288-.719-.239-.191-.479-.287-.718-.287a.922.922 0 0 0-.575.191ZM7.37 9.927H4.45c-.336 0-.527-.143-.527-.479 0-.335.191-.478.526-.478H7.37c.335 0 .48.143.48.478 0 .336-.145.48-.48.48Z' />
);

export const viewBox = '0 0 25 25';
